import type { Blockchain } from "@anaconda/core/blockchain/types"
import {
  type ListingSource,
  SOLANA_EXTERNAL_BUYER_FEE_BPS,
} from "@anaconda/core/nft/listing-source"
import type { PriceValue } from "@anaconda/core/price/types"
import { computed } from "@reatom/core"
import { molecule } from "bunshi"

/** CUT_PRICE: marketplace fee deducted from listing proceeds (seller-side). */
export const SOLANA_MARKETPLACE_SELLER_FEE_BPS = 150

/** Buyer-side fee shown on purchase toasts / quotes until on-chain fee config is wired. */
export const SOLANA_MARKETPLACE_BUYER_FEE_BPS = 150

/**
 * The fee a buyer pays on top of the listed price. An external listing is
 * bought through its own marketplace and pays that marketplace's fee
 * (collection royalties are added by its buy transaction); ours pays ours.
 */
export function getSolanaBuyerFeeBps(listingSource?: ListingSource): number {
  const externalFeeBps = listingSource
    ? SOLANA_EXTERNAL_BUYER_FEE_BPS[listingSource]
    : undefined
  return externalFeeBps ?? SOLANA_MARKETPLACE_BUYER_FEE_BPS
}

export const SolanaFeesMoleculeReatom = molecule(() => {
  const reatomSolanaServiceFeeQuery = ({
    blockchain,
    price,
  }: {
    blockchain: Blockchain
    price: PriceValue | undefined
  }) =>
    computed(
      () => ({
        queryKey: [
          "solana",
          "service-fee",
          blockchain,
          price?.amount,
          price?.currency,
        ],
        queryFn: async (): Promise<number> =>
          SOLANA_MARKETPLACE_SELLER_FEE_BPS / 100,
        staleTime: Number.POSITIVE_INFINITY,
      }),
      `solanaServiceFeeQuery_${blockchain}_${price?.amount}_${price?.currency}`,
    )

  return {
    reatomSolanaServiceFeeQuery,
  }
})
